"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _emotion = require("../../utils/emotion");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _useListState2 = _interopRequireDefault(require("../../hooks/useListState.hook"));
var _Text = _interopRequireDefault(require("../Text"));
var _Button = _interopRequireDefault(require("../Button"));
var _ClickAwayListener = _interopRequireDefault(require("../ClickAwayListener"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _CloseIcon = _interopRequireDefault(require("../CloseIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ComponentsList = function ComponentsList(props) {
  var options = props.options,
    value = props.value,
    onChange = props.onChange,
    label = props.label;
  var _useListState = (0, _useListState2["default"])(),
    state = _useListState.state,
    toggle = _useListState.toggle;
  var rootClass = (0, _useCss["default"])(function (theme) {
    var _ref;
    return _ref = {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      maxWidth: 350,
      left: 0,
      transitionDuration: '200ms',
      overflow: 'hidden',
      borderRight: "1px solid ".concat(theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.low)),
      backgroundColor: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.low, 0.05)
    }, _defineProperty(_ref, theme.screen.down('desktop'), {
      maxWidth: 250
    }), _defineProperty(_ref, theme.screen.down('tablet'), {
      maxWidth: 350,
      position: 'absolute',
      top: 0,
      left: state ? 0 : -400,
      height: '100dvh',
      boxShadow: "".concat(theme.size(0.5), " 0px ").concat(theme.size(0.5), " ").concat(theme.color(theme.palette.accent.primary.contrast.high, 'transparent', 0.25))
    }), _defineProperty(_ref, theme.screen.down('mobile'), {
      maxWidth: '100dvw',
      left: state ? 0 : '-101dvw',
      boxShadow: 'none'
    }), _ref;
  });
  var listClass = (0, _useCss["default"])(function (theme) {
    return {
      flexGrow: 1,
      overflow: 'auto',
      padding: theme.size(1, 0, 2)
    };
  });
  var headerClass = (0, _useCss["default"])(function (theme) {
    return _defineProperty({
      display: 'none',
      backgroundColor: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.low, 0.15),
      borderBottom: "1px solid ".concat(theme.palette.accent.primary.color)
    }, theme.screen.down('mobile'), {
      display: 'flex',
      alignItems: 'center',
      gap: theme.size(2)
    });
  });
  var titleClass = (0, _useCss["default"])(function (theme) {
    return {
      color: theme.color(theme.palette.accent.primary.color, theme.palette.accent.primary.contrast.high, 0.75)
    };
  });
  var buttonClass = (0, _useCss["default"])(function () {
    return {
      justifyContent: 'flex-start'
    };
  });
  var emptyClass = (0, _useCss["default"])(function () {
    return {
      opacity: 0.65
    };
  });
  var handleChange = (0, _react.useCallback)(function (v) {
    return function () {
      onChange(v);
      toggle.off();
    };
  }, [onChange, toggle]);
  var handleClickAway = (0, _react.useCallback)(function () {
    toggle.off();
  }, [toggle]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ClickAwayListener["default"], {
    onClickAway: handleClickAway,
    disabled: !state,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: rootClass,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: headerClass,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
          width: 8,
          height: 5,
          onClick: toggle,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseIcon["default"], {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text["default"], {
          weight: "black",
          size: "large",
          className: titleClass,
          children: label
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: listClass,
        children: options.map(function (opt) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button["default"], {
            fullWidth: true,
            padding: [1, 2],
            title: opt.label,
            className: buttonClass,
            variant: value === opt.value ? 'filled' : 'text',
            onClick: handleChange(opt.value),
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text["default"], {
              size: "large",
              weight: "bold",
              variant: "code",
              className: (0, _emotion.cx)(opt.empty && emptyClass),
              children: ['<', opt.label, ' />']
            })
          }, opt.value);
        })
      })]
    })
  });
};
var _default = ComponentsList;
exports["default"] = _default;